import produce from 'immer';
import margeById from '../../helpers/margeById';

export const actions = {
  GET_FAV_SUPPLIER_PRODUCTS: 'GET_FAV_SUPPLIER_PRODUCTS',
  ADD_FAV_SUPPLIER_PRODUCTS: 'ADD_FAV_SUPPLIER_PRODUCTS',
  REM_FAV_SUPPLIER_PRODUCTS: 'REM_FAV_SUPPLIER_PRODUCTS',

  GET_FAV_SUPPLIER_PRODUCTS_SUCCESS: 'GET_FAV_SUPPLIER_PRODUCTS_SUCCESS',
  ADD_FAV_SUPPLIER_PRODUCTS_SUCCESS: 'ADD_FAV_SUPPLIER_PRODUCTS_SUCCESS',
  REM_FAV_SUPPLIER_PRODUCTS_SUCCESS: 'REM_FAV_SUPPLIER_PRODUCTS_SUCCESS',

  SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_IS_LOADING:
    'SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_IS_LOADING',
  SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_COUNT:
    'SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_COUNT',
  SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_SEARCH_VALUE:
    'SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_SEARCH_VALUE',
};

const initialState = {
  items: [],
  isLoading: false,
  count: 0,
  searchValue: '',
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) {
    return initialState;
  }

  switch (type) {
    case actions.GET_FAV_SUPPLIER_PRODUCTS_SUCCESS: {
      const currentFavSupplierProducts = draft.items;
      draft.items = margeById(currentFavSupplierProducts, payload);
      break;
    }

    case actions.REM_FAV_SUPPLIER_PRODUCTS_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload);
      break;
    }
    case actions.ADD_FAV_SUPPLIER_PRODUCTS_SUCCESS: {
      // TODO
    }

    //   /**
    //    * Misc
    //    */

    case actions.SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }

    case actions.SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_LIST_COUNT: {
      draft.count = payload;
      break;
    }

    case actions.SET_CUSTOMER_FAV_SUPPLIER_PRODUCTS_SEARCH_VALUE: {
      draft.items = [];
      draft.searchValue = payload;
      break;
    }

    default:
      break;
  }
});
